import clsx from "clsx";
import { MediaSmallMobile } from "../../../../api/const/MediaQuery";
import useMediaQuery from "../../../../hook/useMediaQuery";
import { addZero, formatTime } from "../../../../shared/utils/formatFunction";

type DateCardProps ={
    dayName?: string;
    day?:number; 
    month?:string;
    year?:string; 
    hour?:number; 
    minutes?:number
}
export const DatesCard = ({dayName, day, month, year, hour, minutes} : DateCardProps) => {
    
    const smalldevice = useMediaQuery(MediaSmallMobile)
   
    return (
        <div className={clsx("",
        {"me-3" :! smalldevice},
        {"me-1" : smalldevice})}>
            <div className="d-flex flex-column align-items-center preview-card preview-date-card ">
                <p className="p-0 m-0 preview-day-name txt-uppercase">{dayName ? dayName : "DAY" }</p>
                <p className="p-0 m-0 preview-day-number ">{day ? addZero(day) : "DD"}</p>
                <p className="p-0 m-0 preview-month txt-uppercase"><b>{month ? month : "MON"}</b> {year ? year : "YYYY"}</p>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center preview-card p-1 mt-2 ">
                <p className="p-0 m-0 preview-time">{hour && minutes || hour && minutes === 0 ? `${addZero(hour)}:${addZero(minutes)}` : "hh:mm aa"}</p>
            </div>
        </div>
    )
}
